// extracted by mini-css-extract-plugin
export default {"container":"HistoryPage_container_TC2Kc","content":"HistoryPage_content_tJ1q2","menuExpaned":"HistoryPage_menuExpaned_mR7rG","wrapper-report":"HistoryPage_wrapper-report_GfU8D"};